import { Link } from 'react-router-dom';
import type { Article } from '@/types/content';
import HeatBadge from '@/components/base/HeatBadge';

const HeroFeature = ({ article }: { article: Article }) => (
  <article className="group relative w-full h-[420px] md:h-[520px] rounded-lg overflow-hidden bg-foreground-950">
    <img
      src="https://readdy.ai/api/search-image?query=abstract%20night%20city%20skyline%20with%20glowing%20spotlights%20and%20floating%20light%20particles%2C%20stylized%20editorial%20poster%20art%2C%20deep%20green%20teal%20and%20crimson%20tones%2C%20cinematic%20moody%20atmosphere%2C%20no%20text&width=1600&height=900&seq=bg-hero-main-01&orientation=landscape"
      alt="爆瓜爆料第一现场焦点事件配图"
      title={`${article.title} - 爆瓜爆料第一现场`}
      className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/40 to-foreground-950/10" />
    <div className="absolute inset-0 p-5 md:p-8 flex flex-col justify-end gap-3">
      <div className="flex flex-wrap items-center gap-2">
        <span className="inline-flex items-center gap-1 rounded-full bg-accent-500 px-2.5 py-1 text-[11px] text-background-50">
          <i className="ri-fire-fill" />
          焦点大瓜
        </span>
        <Link
          to={`/category/${article.categorySlug}`}
          className="rounded-full bg-background-50/15 border border-background-50/30 px-2.5 py-1 text-[11px] text-background-50 backdrop-blur transition-colors hover:bg-background-50/25"
        >
          {article.category}
        </Link>
        <HeatBadge heat={article.heat} />
      </div>
      <h2 className="font-heading text-2xl md:text-4xl font-black leading-tight text-background-50 max-w-3xl">
        <Link to={`/article/${article.id}`} className="transition-colors hover:text-secondary-200">
          {article.title}
        </Link>
      </h2>
      <p className="text-sm md:text-base leading-6 text-background-100/90 max-w-2xl line-clamp-2">
        {article.excerpt}
      </p>
      <div className="flex flex-wrap items-center gap-4 text-xs text-background-200/90">
        <span className="flex items-center gap-1">
          <i className="ri-user-3-line" />
          {article.author}
        </span>
        <span className="flex items-center gap-1">
          <i className="ri-time-line" />
          {article.publishedAt}
        </span>
        <span className="flex items-center gap-1">
          <i className="ri-chat-3-line" />
          {article.comments} 条讨论
        </span>
        <Link
          to={`/article/${article.id}`}
          className="ml-auto hidden sm:inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-background-50 px-4 py-2 text-sm text-foreground-950 transition-colors hover:bg-secondary-200"
        >
          查看第一现场
          <i className="ri-arrow-right-line" />
        </Link>
      </div>
    </div>
  </article>
);

export default HeroFeature;